<template>
    <div>
        <h2 class="text-center thank-you-heading">Thank You!</h2>
        <p class="text-center paragraph" style="padding: 0px 130px">
            On the basis of the survey, you can bear
            {{ selectedTolerance.tolerance }} Risk and following products are recommended for you:
        </p>
        <ul class="label-ul">
            <li v-for="item in options" :key="item.name" class="label-list">
                {{ item.name }}
            </li>
        </ul>
        <p class="text-center paragraph" style="padding: 0px 130px" v-if="options.length == 0">
            <strong>No Fund Currently available in this category</strong>
        </p>
        <p class="text-center paragraph" style="padding: 0px 130px">
            However using the slider, you can increase your risk and the
            product range
        </p>
    </div>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        selectedTolerance: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {}
    },
}
</script>
<style scoped>
.label-list {
    list-style: none;
    background: #929191;
    padding: 10px;
    color: white;
    margin: 2px;
}
.label-ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-left: 0px;
    padding: 0px 30px;
}
.paragraph {
    font-size: 16px;
    color: #777777;
}
.thank-you-heading {
    color: #4a4a4a;
    font-size: 42px;
}
</style>
